import React, { useState } from 'react'
import { T } from '../traks'
import { AlertModal } from './Modals'
import { Loading } from './Loading'
import { APIPost } from '../API'
import { RenderIf } from '../helpers/RenderIf'
import { SibilusCheckbox } from './Checkbox'
import { TextArea } from './Input'

const CreateComment = ({
	accessId,
	isItMessage = false,
	setMessages = null,
	showMessageChoice = false,
	className = "",
	whistle,
	...props }) => {
	const [comment, setComment] = useState(undefined)
	const [commentAsMessage, setCommentAsMessage] = useState(isItMessage)
	const [showAlert, setShowAlert] = useState(false)
	const [alertType, setAlertType] = useState({ type: "", text: "" })
	const [showLoading, setShowLoading] = useState(false)
	const whistleId = whistle.id

	const createComment = (comment) => {
		setShowLoading(true)
		const resource = `whistles/${whistleId}/log`
		const log_action = commentAsMessage ? "sent_message" : "added_comment"
		const body = {
			comment: comment,
			access_id: accessId,
			action: "create_log",
			log_action: log_action,
			company_id: whistle.company_id
		}
		APIPost(resource, body).then(res => {
			setComment("")
			setShowLoading(false)
			if (setMessages) {
				const log = { ...res.data.log["entry"], ...res.data.log }
				setMessages((prevS) => [...prevS, log])
			}
		}).catch(err => {
			setShowLoading(false)
			setAlertType({ text: err.response.data, type: "error" })
			setShowAlert(true)
		})
	}

	return (
		<div className="d-flex flex-column mt-5">
			<TextArea
				placeholder={!commentAsMessage ? props.render_static(<T>Add a comment</T>) : props.render_static(<T>write message</T>)}
				onChange={setComment}
				initValue={comment}
				className={className}
			/>
			<div className="mt-3">
				<div className="me-3 d-flex flex-row justify-content-end align-items-center">
					<RenderIf condition={showMessageChoice}>
						<SibilusCheckbox 
							id="sendAsMessage"
							checked={commentAsMessage}
							onChange={() => setCommentAsMessage(!commentAsMessage)}
							className="me-3"
						>
							<T>Message can be seen by whistle creator</T>
						</SibilusCheckbox>
					</RenderIf>
					<button onClick={() => createComment(comment)} className="btn btn_green white-text px-4 py-2 fw_700">
						<T>Send</T>
					</button>
				</div>

			</div>
			<div className="mt-4">
			</div>
			<AlertModal
				isShowing={showAlert}
				setIsShowing={setShowAlert}
				type={alertType.type}
				text={alertType.text}
			/>
			<div>
				<Loading
					showLoading={showLoading}
					inFront
					overlay
				/>
			</div>
		</div>
	)
}

export default CreateComment
